import { render, staticRenderFns } from "./VirtualVDataTable.vue?vue&type=template&id=4999ffca&scoped=true"
import script from "./VirtualVDataTable.vue?vue&type=script&lang=js"
export * from "./VirtualVDataTable.vue?vue&type=script&lang=js"
import style0 from "./VirtualVDataTable.vue?vue&type=style&index=0&id=4999ffca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4999ffca",
  null
  
)

export default component.exports